export default {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userType: state => state.user.userType,
  currentRoutes: state => state.routes.currentRoutes,
  keepAliveInclude: state => state.routes.keepAliveInclude
  // AmazonInfo: state => state.user.AmazonInfo
}
